import { Info } from "@phosphor-icons/react";

import useEstimateRenewal from "features/subscriptions/datahooks/useEstimateRenewal";

import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

type ScheduledChangeTagProps =
  | {
      subscriptionId: string;
      type: "avatar";
      rentedCount: number; // Current billed count for this order (unchanged until next billing date).
    }
  | {
      type: "agency";
    };

export default function ScheduledChangeTag(props: ScheduledChangeTagProps) {
  const { estimateRenewal } = useEstimateRenewal(
    props.type === "avatar" ? props.subscriptionId : undefined,
  );

  let perUnitQuantity = 0;

  if (estimateRenewal) {
    const unitItem = (
      estimateRenewal.invoice_estimate || estimateRenewal.next_invoice_estimate
    ).line_items.find(({ pricing_model }) => pricing_model === "per_unit");

    if (unitItem) {
      perUnitQuantity = unitItem.quantity;
    }
  }

  const currentCount = props.type === "avatar" ? props.rentedCount : undefined;
  const newCount = props.type === "avatar" ? perUnitQuantity : undefined;

  const tooltipLabel = props.type === "avatar" ? "order" : "subscription";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Tag variant="yellow" rightIcon={<Info weight="fill" />}>
          Upcoming change
        </Tag>
      </TooltipTrigger>

      <TooltipContent>
        This {tooltipLabel} has a scheduled change which will be effective
        starting from your next billing date
        {props.type === "avatar" && (
          <div className="flex flex-col mt-4">
            <span>Current avatars: {currentCount ?? "—"}</span>

            <span>New avatars: {newCount ?? "—"}</span>
          </div>
        )}
      </TooltipContent>
    </Tooltip>
  );
}
